var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylistThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89285",
    "data-name": "Group 89285",
    transform: "translate(-116 -112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23681",
    "data-name": "Rectangle 23681",
    width: 182,
    height: 182,
    rx: 20,
    transform: "translate(116 112)",
    fill: "#d9d7d7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "audio-waves",
    transform: "translate(152 148.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135408",
    "data-name": "Path 135408",
    d: "M244.176,0A3.177,3.177,0,0,0,241,3.176V105.247a3.176,3.176,0,1,0,6.353,0V3.176A3.177,3.177,0,0,0,244.176,0Z",
    transform: "translate(-189.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135409",
    "data-name": "Path 135409",
    d: "M304.176,77.092A3.177,3.177,0,0,0,301,80.268v69.42a3.176,3.176,0,1,0,6.353,0V80.268A3.177,3.177,0,0,0,304.176,77.092Z",
    transform: "translate(-236.471 -60.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135410",
    "data-name": "Path 135410",
    d: "M364.176,145.435A3.177,3.177,0,0,0,361,148.611v40.475a3.176,3.176,0,0,0,6.353,0V148.611A3.176,3.176,0,0,0,364.176,145.435Z",
    transform: "translate(-283.765 -114.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135411",
    "data-name": "Path 135411",
    d: "M424.176,182.226A3.177,3.177,0,0,0,421,185.4v24.893a3.176,3.176,0,1,0,6.353,0V185.4A3.177,3.177,0,0,0,424.176,182.226Z",
    transform: "translate(-331.059 -143.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135412",
    "data-name": "Path 135412",
    d: "M484.177,212.226A3.177,3.177,0,0,0,481,215.4v12.187a3.176,3.176,0,0,0,6.353,0V215.4A3.177,3.177,0,0,0,484.177,212.226Z",
    transform: "translate(-378.353 -167.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135413",
    "data-name": "Path 135413",
    d: "M184.176,77.092A3.177,3.177,0,0,0,181,80.268v69.42a3.176,3.176,0,1,0,6.353,0V80.268A3.177,3.177,0,0,0,184.176,77.092Z",
    transform: "translate(-141.882 -60.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135414",
    "data-name": "Path 135414",
    d: "M124.176,145.435A3.177,3.177,0,0,0,121,148.611v40.475a3.176,3.176,0,0,0,6.353,0V148.611A3.176,3.176,0,0,0,124.176,145.435Z",
    transform: "translate(-94.588 -114.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135415",
    "data-name": "Path 135415",
    d: "M64.176,182.226A3.177,3.177,0,0,0,61,185.4v24.893a3.176,3.176,0,0,0,6.353,0V185.4A3.177,3.177,0,0,0,64.176,182.226Z",
    transform: "translate(-47.294 -143.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135416",
    "data-name": "Path 135416",
    d: "M4.176,212.226A3.177,3.177,0,0,0,1,215.4v12.187a3.176,3.176,0,0,0,6.353,0V215.4A3.177,3.177,0,0,0,4.176,212.226Z",
    transform: "translate(0 -167.284)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistThumbnail);
export default __webpack_public_path__ + "static/media/playlistThumbnail.33395853da62b7d66a132e27c3af571b.svg";
export { ForwardRef as ReactComponent };